import paths from "routes/paths";
import CommonUtils from "services/common/utils";
import XHTTP from "services/api/xhttp";

class AutomaticSystemsApi {
  static END_POINTS = {
    getAutomaticSystems: paths.api.gates.automaticSystems,
    getAutomaticSystemsDetails: paths.api.gates.automaticSystemsDetails,
    updateAutomaticSystemsMode: paths.api.gates.updateAutomaticSystemsMode,
    updateAutomaticSystemsStatus: paths.api.gates.updateAutomaticSystemsStatus,
  };

  static getAutomaticSystems(filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);
    return XHTTP(`${this.END_POINTS.getAutomaticSystems}?${queryString}`, {
      method: "get",
    });
  }

  static getAutomaticSystemsDetails(id, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);
    return XHTTP(
      `${this.END_POINTS.getAutomaticSystemsDetails.replace(
        ":id",
        id
      )}?${queryString}`,
      {
        method: "get",
      }
    );
  }

  static updateAutomaticSystemsMode(contractId, id, data) {
    return XHTTP(
      `${this.END_POINTS.updateAutomaticSystemsMode.replace(
        ":id",
        id
      )}?contract_id=${contractId}`,
      {
        method: "put",
        body: JSON.stringify(data),
      }
    );
  }

  static updateAutomaticSystemsStatus(contractId, id, data) {
    return XHTTP(
      `${this.END_POINTS.updateAutomaticSystemsStatus.replace(
        ":id",
        id
      )}?contract_id=${contractId}`,
      {
        method: "put",
        body: JSON.stringify(data),
      }
    );
  }
}

export default AutomaticSystemsApi;
